import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const tabTheme: { defaultProps?: ComponentsProps['MuiTab']; styleOverrides?: ComponentsOverrides<Theme>['MuiTab'] } = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: ({ theme }) => ({
            textTransform: 'none',
            color: theme.palette.text.secondary,
        }),
    },
};
